export default {
  user: 'Usuário',
  task: 'Tarefa',
  project: 'Projeto',
};



// WEBPACK FOOTER //
// ./src/i18n/pt-BR/Models.js